import { useEffect } from 'react';

import { loadScriptAsynchronously } from '@bingads-webui-campaign-react/smart-component-util';

import {
  clarityScript,
  mTagScript,
  uetTagScript,
  analyticsUetTagScript,
  activityWatcherScript,
} from './tracking-scripts';

export const useWcpConsent = (isSmartPageRuntimePageWcpConsentEnabled, lang, logger, isRuntime) => {
  useEffect(() => {
    if (!isRuntime) {
      return;
    }

    const locale = lang || document.documentElement.lang || navigator.language || 'en-us';
    const insertScripts = (consent) => {
      const { Analytics, Advertising } = consent;

      if (Analytics) {
        loadScriptAsynchronously({ id: 'clarity-script', inlineCode: clarityScript, logger });
        loadScriptAsynchronously({ id: 'sp-analytics-uettag-script', inlineCode: analyticsUetTagScript, logger });
        loadScriptAsynchronously({ id: 'activity-script', inlineCode: activityWatcherScript, logger });
      }

      if (Advertising) {
        loadScriptAsynchronously({ id: 'mtag-script', inlineCode: mTagScript, logger });
        loadScriptAsynchronously({ id: 'uettag-script', inlineCode: uetTagScript, logger });
      }
    };
    const onConsentChanged = (consent) => {
      insertScripts(consent);
    };

    if (isSmartPageRuntimePageWcpConsentEnabled) {
      // WCP Consent API: https://eng.ms/docs/cloud-ai-platform/devdiv/one-engineering-system-1es/1es-docs/wcp/privacy/wcp-cookie-consent-api?
      window.WcpConsent && window.WcpConsent.init(locale, 'consent-banner', (err, _siteConsent) => { // eslint-disable-line no-unused-expressions
        if (!err) {
          window.siteConsent = _siteConsent;

          const consent = _siteConsent.getConsent();
          insertScripts(consent);
        }
      }, onConsentChanged, window.WcpConsent.themes.light);
    } else {
      insertScripts({ Analytics: true, Advertising: true });
    }
  }, []);
};
